export default __webpack_public_path__ + "deed82ed1abf00e4c474c338e9d9b2cd.svg";